
define('app/board/views/draftInfoView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickSummaryCollection',
	'app/board/collections/pickCollection',
	'app/board/collections/rosterPositionCollection',
	'known/models/leagueInstanceModel',
	'app/board/models/draftStatusModel',
	'app/board/models/positionColorsModel',
	
	//Templates
	'text!app/board/templates/draftInfoRoundPickTemplate.html',
	'text!app/board/templates/draftInfoRosterPickTemplate.html',
], function(
		$, 
		_, 
		Backbone, 
		PickSummaryCollection, 
		PickCollection, 
		RosterPositionCollection, 
		LeagueInstanceModel, 
		DraftStatusModel, 
		PositionColorsModel, 
		draftInfoRoundPickHtml,
		draftInfoRosterPickHtml){
	
	var RosterPickView = Backbone.View.extend({
		initialize: function(options) {
			this.posColors = options.posColors;
			this.rosterPosition = options.rosterPosition;
			this.leagueInst = options.leagueInst;
			this.firstRender = false;			
			
			this.template = _.template(draftInfoRosterPickHtml.trim());
			
			this.listenTo(this.rosterPosition, 'change', this.render);
			this.listenTo(this.posColors, 'change', this.setPickStyles);
		},
		
		render: function () {
			var pos = this.rosterPosition.get('lgPos') != null ? this.rosterPosition.get('lgPos').get('name') : 'Bench';
			
			var html = null;
			if(this.rosterPosition.get('pickId')){
				var teamAbbr = (this.rosterPosition.get('byeWeek') && this.rosterPosition.get('byeWeek') > 0) 
						? this.rosterPosition.get('teamAbbr')+'('+this.rosterPosition.get('byeWeek')+')' 
						: this.rosterPosition.get('teamAbbr');
				
				var name = this.playerNameText() + ' ' + this.rosterPosition.get('playerPos') + '-' + teamAbbr;
				
				if(this.leagueInst.get('draftType') == 'AUCTION'){
					name = '$' + this.rosterPosition.get('auctionValue') + '-' + name;
				}
				
				html = $(this.template({
					pos: pos,
					name: name}));
			} else {
				html = $(this.template({
					pos: pos,
					name: '&nbsp;'}));
				
				if(this.rosterPosition.get('optional')){
					$(html).hide();
				}
			}			
			
			this.setPickElStyle(html);
			
			if(this.firstRender == true){
				this.el = html;
				//this.setElement(html);
				this.firstRender = false;
			} else {
				var oldEl = $(this.el);
				
				this.setElement(html);
				oldEl.replaceWith(html);
			}
			
			return this;
		},
		
		playerNameText: function() {
			var dispName = this.rosterPosition.get('lName');
			
			if(this.rosterPosition.get('fName')){
				dispName += ', ' + this.rosterPosition.get('fName');
			}			
			
			if(this.rosterPosition.get('keeper')){
				dispName += this.rosterPosition.get('lName') + '<sup>(K)</sup>';
			}			
			
			return dispName; 
		},
		
		setPickStyles: function() {
			this.setPickElStyle(this.el);
		},
		
		setPickElStyle: function(el) {
			var color = this.posColors.retrievePosColor(this.rosterPosition.get('playerPos'));
			
			$(el).css({'background-color': color});
		},
	});
	
	var RoundPickView = Backbone.View.extend({
		initialize: function(options) {
			this.pickSummary = options.pickSummary;
			this.posColors = options.posColors;
			this.round = options.round;
			this.pickInRound = options.pickInRound;
			this.leagueInst = options.leagueInst;
			
			this.firstRender = true;
			
			this.template = _.template(draftInfoRoundPickHtml.trim());
			
			this.listenTo(this.pickSummary, 'reset', this.render);
			this.listenTo(this.pickSummary, 'change', this.render);
			this.listenTo(this.posColors, 'change', this.setPickStyles);
		},
		
		render: function () {
			var html = null;
			if(this.pickSummary.get('lName')){
				var teamAbbr = (this.pickSummary.get('byeWeek') && this.pickSummary.get('byeWeek') > 0) 
						? this.pickSummary.get('teamAbbr')+'('+this.pickSummary.get('byeWeek')+')' 
						: this.pickSummary.get('teamAbbr');
				
				var name = this.playerNameText() + ' ' + this.pickSummary.get('playerPos') + '-' + teamAbbr;
				
				if(this.leagueInst.get('draftType') == 'AUCTION'){
					name = this.pickSummary.get('auctionValue') + '-' + name;
				}
				
				html = $(this.template({
					pickNum: this.round + '.' + this.pickInRound,
					name: name}));
			} else {
				html = $(this.template({
					pickNum: this.round + '.' + this.pickInRound,
					name: '&nbsp;'}));
			}			
			
			this.setPickElStyle(html);
			
			if(this.firstRender == true){
				this.el = html;
				//this.setElement(html);
				this.firstRender = false;
			} else {
				var oldEl = $(this.el);
				
				this.setElement(html);
				oldEl.replaceWith(html);
			}
			
			return this;
		},
		
		playerNameText: function() {
			var dispName = this.pickSummary.get('lName');
			
			if(this.pickSummary.get('fName')){
				dispName += ', ' + this.pickSummary.get('fName');
			}
			
			
			if(this.pickSummary.get('keeper')){
				dispName += this.pickSummary.get('lName') + '<sup>(K)</sup>';
			}			
			
			return dispName; 
		},
		
		setPickStyles: function() {
			this.setPickElStyle(this.el);
		},
		
		setPickElStyle: function(el) {
			var color = this.posColors.retrievePosColor(this.pickSummary.get('playerPos'));
			
			$(el).css({'background-color': color});
		}
	});
	
	var DraftInfoView = Backbone.View.extend({
		el: $("#playerRankingStatusWidget"),
		
		initialize: function(options) {
			this.leagueInst = options.leagueInst; //
			this.pickSummaries = options.pickSummaryCollection; //
			this.posColors = options.posColors; //
			this.pickCollection = options.pickCollection; //
			this.draftStatus = options.draftStatus;
			this.rosterPositionCollection = options.rosterPositionCollection;
			
			this.showCurrent = true;
			
			if(this.leagueInst.get('draftType') == 'AUCTION'){
				this.showCurrent = false;
			}
			
			this.pickViews = [];
			this.teamViews = [];
			this.tables = [];
			
			_.bindAll(this, 'changeTable');
			_.bindAll(this, 'changeTableType');
			
			
			this.tableContainer = this.$('#playerRankingsStatusContainer');
			this.tableTypeSelect = this.$('#playerRankingsStatusTypeSelect');
			this.roundSelect = this.$('#playerRankingsStatusRoundSelect');
			this.teamSelect = this.$('#playerRankingsStatusTeamSelect');
			this.currentCheckbox = this.$('#playerRankingsStatusCurrentCheckbox');
			
			
			this.tableTypeSelect.on('change', this.changeTableType);
			this.roundSelect.on('change', this.changeTable);
			this.teamSelect.on('change', this.changeTable);
			this.currentCheckbox.on('click', this.changeTable);
			
			this.draftStatus.bind("change", this.changeTable, this);
		},
		
		render: function () {		
			this.tableContainer.empty();
			
			if(this.leagueInst.get('draftType') != 'AUCTION'){
				this.renderRounds();
				this.renderRoundDropdown();
			} else {
				this.tableTypeSelect.hide();
				this.$('#playerRankingsStatusCurrentLabel').hide();
			}	
			
			this.renderTeamRosters();
			this.renderTeamDropdown();
			
			this.changeTableType();
			
			return this;
		},
		
		renderTeamDropdown: function() {
			var sortedTeams = this.leagueInst.getTeamList();
			
			var optionStart = "<option value=\"";
			var optionMiddle = "\" >";
			var optionEnd = "</option>";
			
			this.teamSelect.empty();
			var firstSelected = false;
			
			_.each(sortedTeams, function(team){
				var selected = "";
				
				if(!firstSelected){
					selected = "\" selected=\"true";
					firstSelected = true;
				}
				
				this.teamSelect.append(optionStart 
						+ team.get('id')
						+ selected
						+ optionMiddle
						+ team.get('teamName')						
						+ optionEnd);
			}, this);
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
		},
		
		renderTeamRosters: function() {
			var sortedTeams = this.leagueInst.getTeamList();
			var curTableBody = null;			
			
			_.each(sortedTeams, function(team){
				var posArr = this.rosterPositionCollection.teamRoster[team.get('id')];
				
				curTableBody = $('<tbody></tbody>');
				var newTable = $('<table class="table table-bordered hide" id="draftInfoRoster' + team.get('id') + 'Table"></table>');
				newTable.append(curTableBody);
				
				this.tableContainer.append(newTable);
				this.tables.push(newTable);
				
				for(var i=0; i<posArr.length; i++){
					var pickView = new RosterPickView({
						posColors: this.posColors,
						rosterPosition: this.rosterPositionCollection.get(posArr[i]),
						leagueInst: this.leagueInst});
					curTableBody.append(pickView.render().el);
					this.teamViews[i] = pickView;
				}
			}, this);
		},
		
		renderRoundDropdown: function() {
			var numRounds = this.leagueInst.get('numRounds');
			
			var optionStart = "<option value=\"";
			var optionMiddle = "\" >";
			var optionEnd = "</option>";
			
			this.roundSelect.empty();
			
			for(var i=1; i <= numRounds; i++) {
				var selected = "";
				
				if(i == 1){
					selected = "\" selected=\"true";
				}
				
				this.roundSelect.append(optionStart 
						+ i
						+ selected
						+ optionMiddle
						+ i						
						+ optionEnd);
			}
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
		},
		
		changeTableType: function() {
			var type = this.tableTypeSelect.val();
			
			if(type == "ROSTER" || this.leagueInst.get('draftType') == 'AUCTION') {
				this.roundSelect.hide();
				this.teamSelect.show();
			} else {
				this.teamSelect.hide();
				this.roundSelect.show();
			}
			
			this.changeTable();
		},
		
		changeTable: function() {
			this.hideAllTables();
			var type = this.tableTypeSelect.val();
			var dropdownValue = null;
			
			var foundEl = null;
			
			var showCurrent = this.currentCheckbox.prop("checked");
			
			if(this.leagueInst.get('draftType') == 'AUCTION'){
				showCurrent = false;
			}
			
			if(showCurrent) {
				this.showCurrent = true;
				this.teamSelect.prop("disabled", true);
				this.roundSelect.prop("disabled", true);
				this.teamSelect.val(this.draftStatus.get('draftingTeamId'));
				this.roundSelect.val(this.draftStatus.get('round'));
			} else {
				this.showCurrent = false;
				this.teamSelect.prop("disabled", false);
				this.roundSelect.prop("disabled", false);
			}
			
			if(type == "ROSTER" || this.leagueInst.get('draftType') == 'AUCTION') {
				dropdownValue = this.showCurrent ? this.draftStatus.get('draftingTeamId') : this.teamSelect.val();
				foundEl = $(this.el).find('#draftInfoRoster' + dropdownValue + 'Table');
			} else {
				dropdownValue = this.showCurrent ? this.draftStatus.get('round') : this.roundSelect.val();
				foundEl = $(this.el).find('#draftInfoRound' + dropdownValue + 'Table');
			}
			
			if(foundEl){
				foundEl.show();
			}
		},
		
		renderRounds: function () {
			var curTableBody = null;
			for (var round = 1; round <= this.leagueInst.get('numRounds'); round++) {
				curTableBody = $('<tbody></tbody>');
				var newTable = $('<table class="table table-bordered hide" id="draftInfoRound' + round + 'Table"></table>');
				newTable.append(curTableBody);
				
				this.tableContainer.append(newTable);
				this.tables.push(newTable);
				
				var numPicksInRound =  this.leagueInst.numTeams();				
				if(this.leagueInst.get('draftType') == 'CUSTOM'){
					numPicksInRound = this.pickCollection.getPicksByRound(round).length;
				}
				
				for (var posInRound = 1; posInRound <= numPicksInRound; posInRound++) {
					var pickSummaryModel = this.pickSummaries.get(this.pickSummaries.getPosRoundId(round, posInRound));
					
					var pickView = new RoundPickView({
							pickSummary: pickSummaryModel,
							posColors: this.posColors,
							round: round,
							pickInRound: posInRound,
							leagueInst: this.leagueInst});
					curTableBody.append(pickView.render().el);
					this.pickViews[pickSummaryModel.get('id')] = pickView;
				}				
				
			}
		},
		
		hideAllTables: function() {
			for(var i=0; i<this.tables.length; i++){
				this.tables[i].hide();
			}
		}
	});
	
	return DraftInfoView;  
});